import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';
import {
  TimingPair,
  timingPairStringify,
} from '@faire/web/common/timings/TimingMarker';

export const eventKey = 'search-search_suggestion_loaded-view';

/**
 * TimingPair event for loading/displaying a suggestion
 */
export function trackSearchSearchSuggestionLoadedView(
  timingParameterToken: TimingPair
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: {
      timingParameterToken: timingPairStringify(timingParameterToken) ?? '',
    },
  });
}
